import cn from 'classnames'
import React, { ComponentProps, ReactElement, ReactNode } from 'react'

import style from './RoundCard.style'

type RoundCardProps = {
  className?: string
  children: ReactNode
  variant?: 'highlight' | 'plain'
} & ComponentProps<'div'>

function RoundCard(props: RoundCardProps): ReactElement {
  const { className = '', variant = 'plain', children, ...rest } = props

  return (
    <div className={cn('RoundCard', className, variant)} css={style} {...rest}>
      {children}
    </div>
  )
}

export default RoundCard
